import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Portfolio from './pages/Portfolio/Portfolio';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Stories from './pages/Stories/Stories';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import './App.css';

function AnimatedRoutes() {
  const location = useLocation();
  // Switching sub-collection filter (/portfolio/travels → /portfolio/travels/japan)
  // stays on the same page: no remount, no page fade
  const portfolioMatch = location.pathname.match(/^\/portfolio\/[^/]+/);
  const pageKey = portfolioMatch ? portfolioMatch[0] : location.key;

  return (
    <div key={pageKey} className="page-enter">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:category" element={<Portfolio />} />
        <Route path="/portfolio/:category/:sub" element={<Portfolio />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
    </div>
  );
}

function App() {
  useEffect(() => {
    // Only redirect from .com — skip localhost and .fr
    if (!window.location.hostname.endsWith('.com')) return;
    // User explicitly chose English: respect their choice
    if (localStorage.getItem('preferredLanguage') === 'en') return;

    fetch('https://ipapi.co/country/')
      .then(r => r.text())
      .then(country => {
        if (country.trim() === 'FR') {
          window.location.replace(
            `https://antoinepierson.fr${window.location.pathname}${window.location.search}`
          );
        }
      })
      .catch(() => {}); // Fail silently — never block the site
  }, []);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <div className="app">
        <Header />
        <main className="main-content">
          <AnimatedRoutes />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
